import Divider from "@mui/material/Divider";
import FormControlLabel from "@mui/material/FormControlLabel";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Input, Select, Switch } from "@andorhealth/clientuireact.designsystem";
import { useConfiguration } from "../hooks/useConfiguration";

export function DefaultsStep() {
  const {
    wakePhrase,
    setWakePhrase,
    wakeOnnx,
    setWakeOnnx,
    voiceAgentId,
    setVoiceAgentId,
    webhookSecret,
    setWebhookSecret,
    updateWebhook,
    setUpdateWebhook,
    defaultPolicyId,
    setDefaultPolicyId,
    configEnabled,
    setConfigEnabled,
    hasWebhookSecret,
    catalog,
  } = useConfiguration();

  return (
    <Stack spacing={2}>
      <Typography sx={{ color: "text.secondary" }}>
        Default coverage uses a path that is already saved. “Use the path from
        earlier” keeps the current default.
      </Typography>
      <Input
        label="Wake phrase"
        value={wakePhrase}
        onChange={(event) => setWakePhrase(event.target.value)}
        helperText="What patients say to start (shown on screen)"
      />
      <Input
        label="Wake sound file"
        value={wakeOnnx}
        onChange={(event) => setWakeOnnx(event.target.value)}
      />
      <Input
        label="Default voice assistant (tenant)"
        value={voiceAgentId}
        onChange={(event) => setVoiceAgentId(event.target.value)}
        helperText="Fallback ElevenLabs agent id when no org/site/location override matches"
      />
      <Select
        label="Default coverage"
        value={defaultPolicyId}
        options={[
          { label: "Use the path from earlier", value: "" },
          ...(catalog?.policies ?? []).map((policy) => ({
            label: policy.displayName,
            value: policy.escalationPolicyId,
          })),
        ]}
        onChange={(event) =>
          setDefaultPolicyId(
            String(event.target.value) === "" ? "" : Number(event.target.value),
          )
        }
      />
      <FormControlLabel
        control={
          <Switch
            checked={configEnabled}
            onChange={(event) => setConfigEnabled(event.target.checked)}
          />
        }
        label="On"
      />
      <Divider />
      <FormControlLabel
        control={
          <Switch
            checked={updateWebhook}
            onChange={(event) => setUpdateWebhook(event.target.checked)}
          />
        }
        label={
          hasWebhookSecret
            ? "Change connection password"
            : "Set connection password"
        }
      />
      {updateWebhook ? (
        <Input
          label="Connection password"
          type="password"
          value={webhookSecret}
          onChange={(event) => setWebhookSecret(event.target.value)}
        />
      ) : null}
    </Stack>
  );
}
